import React, { useState, useEffect } from 'react';

// import CollectionPreferences from "@amzn/awsui-components-console/collection-preferences";
import {
    Box,
    Container,
    Header,
    Pagination,
    Button,
    StatusIndicator
} from "@amzn/awsui-components-react";

import { getDocumentFromVault } from '../VaultAPIs';

function DocumentViewer(props) {

    const [fetchedFile, setFetchedFile] = useState(false)
    const [presignedURL, setPresignedURL] = useState('')
    useEffect(() => {
        fetchDocument()
    }, [props])

    const fetchDocument = async () => {
        setFetchedFile(false)
        if(props?.contentType && props?.service && props?.serviceParams) {
            let result = await getDocumentFromVault(props?.contentType, props?.service, props?.serviceParams)
            setPresignedURL(result?.fileUrl)
        }
        setFetchedFile(true)
    }

    return (
        fetchedFile === true ? <>
            <iframe
                className={props.viewType === 'expandable' ? "expandable_embedment" : "fixed_embedment"}
                src={presignedURL}>
            </iframe>
        </> : 
    <StatusIndicator colorOverride="blue" type="loading">
      Fetching and preparing the document...
    </StatusIndicator>
    )


}

export default DocumentViewer;